import { render, staticRenderFns } from "./comp9.vue?vue&type=template&id=c302a8e2&scoped=true"
import script from "./comp9.vue?vue&type=script&lang=ts"
export * from "./comp9.vue?vue&type=script&lang=ts"
import style0 from "./comp9.vue?vue&type=style&index=0&id=c302a8e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c302a8e2",
  null
  
)

export default component.exports